<template>
  <!--
    Menu Ações do Diário de Auxiliares de 2026 em diante (#7286, Cenário 1).

    Componente separado do legado de propósito: anos anteriores a 2026 não podem ser
    afetados por mudança feita aqui.
  -->
  <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        color="indigo"
        dark
        v-bind="attrs"
        v-on="on"
        :id="`btn-acoes-auxiliares-${gestaoDeAulas.id}`"
      >
        AÇÕES
      </v-btn>
    </template>

    <v-card class="mx-auto" max-width="300">
      <v-list>
        <v-list-item>
          <v-list-item-avatar color="primary">
            <v-list-item-title style="color: #fff">{{ inicialDoAluno }}</v-list-item-title>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{
              gestaoDeAulas.nomeProfessor ? gestaoDeAulas.nomeProfessor : "- - -"
            }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ gestaoDeAulas.nomeTurma ? gestaoDeAulas.nomeTurma : "- - -" }} /
              {{ nomeDoAluno }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list dense>
        <v-list-item-group color="primary">
          <v-list-item
            :id="`item-relatorios-diarios-${gestaoDeAulas.id}`"
            :to="{
              name: 'atendimentosAuxiliares',
              params: { gestaoId: gestaoDeAulas.id },
            }"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-list</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Relatórios Diários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            :id="`item-lancar-pei-${gestaoDeAulas.id}`"
            @click="$emit('lancar-pei', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-book</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Lançar PEI</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            :id="`item-baixar-pei-${gestaoDeAulas.id}`"
            @click="$emit('baixar-pei', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-file-pdf</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Baixar P.E.I</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <!-- Editar e Apagar Gestão: só perfis de gestão (Cenário 1) -->
        <v-list-item-group
          color="primary"
          v-if="podeGerenciarGestao && !gestaoDeAulas.estaDeletado"
        >
          <v-list-item
            :id="`item-editar-gestao-${gestaoDeAulas.id}`"
            @click="$emit('editar', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Editar Gestão</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            :id="`item-apagar-gestao-${gestaoDeAulas.id}`"
            @click="$emit('deletar', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-trash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Apagar Gestão</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

// Cenário 1: Editar/Apagar Gestão só para estes perfis.
const ROLES_QUE_GERENCIAM_GESTAO = [
  "coordenador",
  "direção",
  "supervisor",
  "secretario",
  "secretario-escolar",
  "admin",
  "super-admin",
];

export default {
  name: "EAcoesAuxiliares2026",
  props: {
    gestaoDeAulas: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeGerenciarGestao() {
      const roleName = this.user && this.user.role ? this.user.role.name : "";
      return ROLES_QUE_GERENCIAM_GESTAO.includes(roleName);
    },
    nomeDoAluno() {
      return this.gestaoDeAulas.matricula ? this.gestaoDeAulas.matricula.nomecompleto : "- - -";
    },
    inicialDoAluno() {
      const nome = this.nomeDoAluno;
      return nome && nome !== "- - -" ? nome.substring(0, 1).toUpperCase() : "-";
    },
  },
};
</script>
